<template>
  <div class="sns-account">
    <p v-if="isTwitterBtnShow || isLineBtnShow" class="text" v-html="$t('text010')" />
    <div class="share-buttons">
      <button v-if="isTwitterBtnShow" class="follow-btn twitter" @click="twitterAccount()">
        <img src="@images/sns-share/icon_twitter.png" />
      </button>
      <button v-if="isLineBtnShow" class="follow-btn line" @click="lineAccount()">
        <img src="@images/sns-share/icon_line.png" />
      </button>
    </div>
  </div>
</template>
<script>
import localeMenu from '@locales/menu'
export default {
  name: 'sns-account',
  $messages: localeMenu,
  computed: {
    isTwitterBtnShow(){
      const showlang = ['ja-JP', 'en-GB', 'en-US']
      return showlang.some(l => l === this.$route.params.lang)
    },
    isLineBtnShow(){
      return this.$route.params.lang === 'ja-JP'
    }
  },
  methods: {
    twitterAccount(){
      const path = this.$route.params.lang === 'ja-JP' ? 'https://twitter.com/FE_Heroes_JP' : 'https://twitter.com/FE_Heroes_EN'
      window.open(path, '_blank')
    },
    lineAccount(){
      window.open('https://line.me/R/ti/p/%40xod1361s', '_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
.sns-account {
  > .text {
    color: #000;
    text-align: center;
    font-size: $fs-base * 1.4;
    margin: 0 20px;
  }
  > .share-buttons {
    background-image: url(#{$img-path}sns-account/bg_sns.png);
    background-position: 0 50%;
    background-repeat: repeat-x;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    > .follow-btn {
      padding: 0;
      background-color: transparent;
      margin: 0 20px;
      @include tap-event();
      img {
        width: 100%;
      }
    }
  }
}
</style>